import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
  SalesPlanService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "party-sales-order-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./PartySalesOrderReport.html",
})
export class PartySalesOrderReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("params") params: any;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  dataList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter = {
    season_id: 0,
  };
  exceldata: any;
  page = {
    limit: 99999,
    count: 0,
    offset: 0,
    orderBy: "agent_name",
    orderDir: "asc",
  };
  finyearList = [];
  agentList = [];
  printConfig: any = {
    title: "Party Sales Order report",
    columns: [],
    rows: [],
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  gradeCtrl: FormControl = new FormControl();
  gradeList = ["A", "B", "C", "D"];
  columns = [];
  gridOptions: any;
  toggleCol = [];
  menu: any;
  reportName = "Sales";

  filterExpand = false;
  filterData: any = {
    fin_id: 3,
    genLedid: "",
    grade: "",
    //company_id: 0
  };
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private combo: Combo2Service,
    private salesplanservice: SalesPlanService,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) {}

  loadParams() {
    let params = this.params;
    this.reportName = params.type;
  }
  ngOnInit(): void {
    if (this.params) {
      this.loadParams();
    }
    this.loadingIndicator = false;
    this.LoadFinYearList();
    if (this.menu.param == "sales") {
      this.reportName = "Sales";
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          type: "sno",
        },

        {
          name: "Name",
          prop: "party_name",
          minWidth: 250,
          maxWidth: 250,
          width: 250,
        },

        {
          name: "Sales Qty",
          cellClass: "txtRight",
          prop: "sale_qty",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
          summary: "sum",
        },
      ];
    } else if (this.menu.param == "orders") {
      this.reportName = "Wise Yearly";

      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          sortable: false,
          type: "sno",
        },
        {
          name: "Name",
          prop: "party_name",
          minWidth: 250,
          maxWidth: 250,
          width: 250,
        },
        {
          name: "Order Qty",
          cellClass: "txtRight",
          prop: "order_qty",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
          summary: "sum",
        },
      ];
    } else {
      this.columns = [
        //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: false, checkboxable :true},
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          type: "sno",
        },
        {
          name: "Name",
          prop: "party_name",
          minWidth: 250,
          maxWidth: 250,
          width: 250,
        },
        {
          name: "Order Qty",
          cellClass: "txtRight",
          prop: "order_qty",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
          summary: "sum",
        },
        {
          name: "Sales Qty",
          cellClass: "txtRight",
          prop: "sale_qty",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
          summary: "sum",
        },
        {
          name: "Diff Qty",
          cellClass: "txtRight",
          prop: "diff_qty",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
          summary: "sum",
        },
      ];
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.checkuser();

    // this.pageCallback({ offset: 0 });
  }

  checkuser() {
    let that = this;

    if (this.user.params && !this.user.params.agent_id) {
      that.agentVisible = true;
    }
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    this.getPartySalesOrder();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getPartySalesOrder();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getPartySalesOrder();
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      var a = document.querySelector(
        ".mat-autocomplete-panel.mat-autocomplete-visible"
      );
      // a.classList=["mat-autocomplete-panel"];
      $("#" + nextEl).focus();
    }
  }

  getPartySalesOrder(): void {
    let params: any;
    if (this.user.username == "admin") {
      params = {
        start: `${this.page.offset * (this.page.limit + 1)}`,
        limit: `${this.page.limit}`,
        page: "1",
        // name:this.filterData.name,
        grade: this.filterData.grade,
        orderColumn: `${this.page.orderBy}`,
        orderDir: `${this.page.orderDir}`,
        //   filter: JSON.stringify(this.filter),
        filter: this.filterData.fin_id,

        filterdata: this.filterData.genLedid,

        // tabTitle: this.title
      };
    } else {
      params = {
        start: `${this.page.offset * (this.page.limit + 1)}`,
        limit: `${this.page.limit}`,
        page: "1",
        // name:this.filterData.name,
        grade: this.filterData.grade,
        orderColumn: `${this.page.orderBy}`,
        orderDir: `${this.page.orderDir}`,
        //   filter: JSON.stringify(this.filter),
        filter: this.filterData.fin_id,

        filterdata: this.user.params.agent_id,

        // tabTitle: this.title
      };
    }
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getPartySalesOrder(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        // that.dataList = res.data;
        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };

        that.page.count = res.data.length;

        that.exceldata = that.getData(that.columns, res.data);
        //that.page.count = res.total;
        //that.refreshData();
        that.printConfig = {
          title: "Party Sales Order report",
          columns: that.columns,
          rows: that.gridOptions.data,
        };
        that.refreshData();
        //  that.columns = res.columns;
      });
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearFilter(): void {
    this.filterData = {
      fin_id: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getPartySalesOrder();
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      let fin = res.data[0],
        fin_id = fin["fin_id"];
      if (that.params && that.params.data) {
        fin_id = that.params.data.fin_id;
        that.filterData.fin_id = fin_id;
        that.finyearCtrl.setValue(fin_id);
      } else {
        that.filterData.fin_id = fin_id;
        that.finyearCtrl.setValue(fin_id);
        that.applyFilter();
      }
      this.LoadAgentList();
    });
  }

  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Agent") {
      list = this.agentList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  LoadAgentList() {
    let that = this;
    this.salesplanservice.getAgentList({}).then((res: any) => {
      that.agentList = res.data;
      if (that.params && that.params.data) {
        let agent_id = that.params.data.agent_id;
        that.filterData.genLedid = agent_id;
        that.agentCtrl.setValue(agent_id + "");
        that.applyFilter();
      } else {
      }
    });
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }
  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }
  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/PartySalesOrderReport/PartySalesOrderReport.ts